import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, from, Observable, of, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { uploadFileReturn } from '../upload/upload.service';
import { ImanagersCsvImportForm } from '../form/forms.service';

@Injectable({
  providedIn: 'root',
})
export class ManagerService {
  // for the clinicalpreferences endpoint update
  private managerID = new BehaviorSubject<string>('');
  private clinicalPrefID = new BehaviorSubject<string>('');

  constructor(private http: HttpClient) {}

  getManagerID = (): Observable<any> => {
    return this.managerID.asObservable();
  };
  setManagerID = id => {
    this.managerID.next(id);
  };

  getClinicalPrefID = (): Observable<any> => {
    return this.clinicalPrefID.asObservable();
  };
  setClinicalPrefID = id => {
    this.clinicalPrefID.next(id);
  };

  /**
   * Endpoint to create a provisional manager
   * @param body
   */
  provisionalManagerSignup(body: any) {
    if (body) {
      return this.http.post(`${environment.api}/managements/signup`, body);
    }
  }

  /**
   * Endpoint to update manager preferences
   * @param body
   */
  updateManagerClinicalPreferences(body: any) {
    if (body) {
      return this.http.post(`${environment.api}/managements/updateclinicalpreferences`, body);
    }
  }

  /**
   * Query for managers for auto complete selection interface
   * @param body
   */
  managerSelectionQuery(body: any) {
    if (body) {
      return this.http.post(`${environment.api}/managements/findhostsassociatedmanagers`, body);
    }
  }

  /**
   * Associate a manager with a specific host
   * @param body
   */
  associateManagerWithHost(body: any) {
    if (body) {
      return this.http.post(`${environment.api}/managements/addmanagertohost`, body);
    }
  }

  /**
   * Associate a manager with a specific program
   * @param body
   */
  associateManagerWithProgram(body: any) {
    if (body) {
      return this.http.post(`${environment.api}/managements/addmanagertoprogram`, body);
    }
  }

  listManagerAssociations(body: any) {
    return this.http.post(`${environment.api}/managements/listmanagerassociations`, body);
  }

  removeManagerAssociation(body: any) {
    return this.http.post(`${environment.api}/managements/removemanagerassociations`, body);
  }
  /**
   * AMO employee updating a manager
   * @param body
   */
  amoUpdateManager(body: any) {
    return this.http.put(`${environment.api}/managements/${body.id}/update`, body);
  }
  /**
   * AMO employee delete a manager
   * @param manangerId
   */
  amoDeleteManager(manangerId: string) {
    return this.http.delete(`${environment.api}/managements/${manangerId}/destroy`);
  }

  /**
   * AMO employee send a email to a manager
   * @param type
   * @param manangerId
   */
  triggerManagerEmail(type: string, managerId: string) {
    return this.http.get(`${environment.api}/managements/${managerId}/triggermanageremail?type=${type}`);
  }

  adminGetCognitoUser(managerId: string) {
    return this.http.get(`${environment.api}/managements/${managerId}/admingetuser`);
  }

  showManager(managerId: string) {
    return this.http.get(`${environment.api}/managements/${managerId}/show`);
  }

  adminSetManagerMFAPreference(body: any) {
    return this.http.post(`${environment.api}/managements/adminsetmanagermfapreference`, body);
  }

  adminDeleteCognitoManager(body: any) {
    return this.http.post(`${environment.api}/managements/deletecognitomanager`, body);
  }

  createManagerAssignDepartmentCsvUpload(body: ImanagersCsvImportForm): Observable<uploadFileReturn> {
    return this.http.post<uploadFileReturn>(`${environment.api}/managements/createmanagerassigndepartmentcsvupload`, body);
  }

  saveDocumentUploadToPreferences(key: string, type: string, fileName: string, managerid: string) {
    const body = { key: key, type: type, filename: fileName };
    return this.http.post(`${environment.api}/managements/${managerid}/savemanagerdocupload`, body);
  }

  validateHubspotManager(managerid: string, hubspotcontactid: string): Observable<any> {
    return this.http.post(`${environment.api}/managements/${managerid}/validateHubspotManager?ngsw-bypass=true`, { hubspotcontactid });
  }

  promptAmoIntelligence(question: string, sessionId: string, userId: string): Observable<any> {
    console.log('promptAmoIntelligence', question);
    return this.http.post(`${environment.api}/managements/promptami?ngsw-bypass=true`, { question, sessionId, userId });
  }

  intentAmoIntelligence(intent: string, sessionId: string, userId: string): Observable<any> {
    return this.http.post(`${environment.api}/managements/intentami?ngsw-bypass=true`, { intent, sessionId, userId });
  }

  checkManagerPreferences() {
    return this.http.get(`${environment.api}/managements/checkmanagerpreferences`);
  }

  saveManagerClinicalPreferences(body: any) {
    return this.http.post(`${environment.api}/managements/updatemanagerclinicalpreferencesblock`, body);
  }

  getAdminStudentTypeListNotAuthorized() {
    return this.http.get(`${environment.api}/adminstudenttypes/list-trim`);
  }

  getHubspotDashboardProps(): Observable<any> {
    return this.http.get(`${environment.api}/managements/gethubspotdashboardprops`);
  }

  getHubspotSignedUrl(filePath): Observable<any> {
    return this.http.get(`${environment.api}/managements/gethubspotsignedurl/${filePath}`);
  }

  deactivateManager(managerId: string): Observable<any> {
    return this.http.post(`${environment.api}/managements/deactivatemanager`, { id: managerId });
  }
}
